import { lazy } from 'react';

// project import
import GuestGuard from '../utils/route-guard/GuestGuard';
import CommonLayout from '../layout/CommonLayout';
import Loadable from '../components/Loadable';

// render - login
const AuthLogin = Loadable(lazy(() => import('../pages/auth/login')));
const AuthPasswordResetRequest = Loadable(lazy(() => import('../pages/auth/password-reset-request')));
const AuthPasswordResetCheckEmail = Loadable(lazy(() => import('../pages/auth/password-reset-check-email')));
const AuthPasswordResetFinish = Loadable(lazy(() => import('../pages/auth/password-reset-finish')));
const AuthSetPassword = Loadable(lazy(() => import('../pages/auth/set-password')));

// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
	path: '/',
	children: [
		{
			path: '/',
			element: (
				<GuestGuard>
					<CommonLayout />
				</GuestGuard>
			),
			children: [
				{
					path: '/',
					element: <AuthLogin />,
				},
				{
					path: 'login',
					element: <AuthLogin />,
				},
				{
					path: 'password-reset/request',
					element: <AuthPasswordResetRequest />,
				},
				{
					path: 'password-reset/check-email',
					element: <AuthPasswordResetCheckEmail />,
				},
				{
					path: 'password-reset/finish/:token',
					element: <AuthPasswordResetFinish />,
				},
				{
					path: 'set-password/:token',
					element: <AuthSetPassword />,
				},
			],
		},
	],
};

export default LoginRoutes;
